<template>
  <el-dialog
      class="meeting-calendar-dialog"
      fullscreen
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      :before-close="handleClose">
    <div class="container">
      <meeting-scheduler-calendar
          class="left-container"
          ref="meetingCalendarREF"
          @eventClick="eventClick"
          :events="events"/>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import moment from "moment";
import MeetingSchedulerCalendar from "./meetingSchedulerCalendar";
export default {
  name: "MeetingCalendar",
  components: { MeetingSchedulerCalendar },
  data(){
    return {
      dialogVisible: null,
      events: []
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    }
  },
  methods:{
    openModal() {
      this.list()
    },
    list(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/calendarMeeting/list`)
          .then(response => {
            console.log('----', response)
            let arr = response.data.list
            for (let i = 0; i < arr.length; i++) {
              console.log('=-=-=-=-=-=-0', moment(arr[i].start_date, 'X').format('YYYY-MM-DD HH:mm'))
              arr[i].start_date = moment(arr[i].start_date, 'X').format('YYYY-MM-DD HH:mm')
              arr[i].end_date = moment(arr[i].end_date, 'X').format('YYYY-MM-DD HH:mm')
            }
            this.events = arr
            this.dialogVisible = true
            console.log('this.events', this.events)
            loader.hide()
            setTimeout(()=>{
              const overlay = document.getElementsByClassName('v-modal');
              if (overlay[0]) {
                overlay[0].style.display = "none"
              }
            }, 300)
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    eventClick(val) {
      console.log('val', val)
      this.$emit('meetingEventClick', val)
      this.$nextTick(() => {
        this.dialogVisible = false
      })
    },
    handleClose () {
      // this.$refs.schedulerREF.closeScheduler();
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.meeting-calendar-dialog{
  /deep/.el-dialog__body{
    height: 90%;
  }
}
.container {
  height: 100%;
  width: 100%;
}

.left-container {
  overflow: hidden;
  position: relative;
  height: 100%
}

</style>
